/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListContainer2_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"CommentContainer_viewer" | "IgnoredTombstoneOrHideContainer_viewer" | "ReplyListContainer3_viewer">;
    readonly " $refType": "ReplyListContainer2_viewer";
};
export type ReplyListContainer2_viewer$data = ReplyListContainer2_viewer;
export type ReplyListContainer2_viewer$key = {
    readonly " $data"?: ReplyListContainer2_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer2_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListContainer2_viewer",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "IgnoredTombstoneOrHideContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListContainer3_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = 'c6720ddd32c295a06e889dbed7e6ce12';
export default node;
